// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file repos/tree/v1/commit_info.proto (package github.repos.tree.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SafeHtml } from "../../../common/v1/safe_html_pb";
import { file_common_v1_safe_html } from "../../../common/v1/safe_html_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file repos/tree/v1/commit_info.proto.
 */
export const file_repos_tree_v1_commit_info: GenFile = /*@__PURE__*/
  fileDesc("Ch9yZXBvcy90cmVlL3YxL2NvbW1pdF9pbmZvLnByb3RvEhRnaXRodWIucmVwb3MudHJlZS52MSKsAQoRQ29tbWl0SW5mb1BheWxvYWQSRQoHZW50cmllcxgBIAMoCzI0LmdpdGh1Yi5yZXBvcy50cmVlLnYxLkNvbW1pdEluZm9QYXlsb2FkLkVudHJpZXNFbnRyeRpQCgxFbnRyaWVzRW50cnkSCwoDa2V5GAEgASgJEi8KBXZhbHVlGAIgASgLMiAuZ2l0aHViLnJlcG9zLnRyZWUudjEuQ29tbWl0SW5mbzoCOAEicQoKQ29tbWl0SW5mbxILCgNvaWQYASABKAkSCwoDdXJsGAIgASgJEgwKBGRhdGUYAyABKAkSOwoXc2hvcnRfbWVzc2FnZV9odG1sX2xpbmsYBCABKAsyGi5naXRodWIuY29tbW9uLnYxLlNhZmVIdG1sYgZwcm90bzM", [file_common_v1_safe_html]);

/**
 * Payload describing per-entry commit information for a directory listing,
 * as returned alongside the tree view's React payload.
 *
 * Defined by Repos::TreePayloadHelper#commit_info_payload_proto.
 *
 * `short_message_html_link` is a message (not a scalar) so its absence —
 * when the underlying commit has an empty message — stays distinguishable
 * on the wire from an empty string.
 *
 * @generated from message github.repos.tree.v1.CommitInfoPayload
 */
export type CommitInfoPayload = Message<"github.repos.tree.v1.CommitInfoPayload"> & {
  /**
   * Keyed by directory entry name (the content's display name). Order is not
   * significant on the wire; clients reconstruct ordering from the directory
   * listing.
   *
   * @generated from field: map<string, github.repos.tree.v1.CommitInfo> entries = 1;
   */
  entries: { [key: string]: CommitInfo };
};

/**
 * Describes the message github.repos.tree.v1.CommitInfoPayload.
 * Use `create(CommitInfoPayloadSchema)` to create a new message.
 */
export const CommitInfoPayloadSchema: GenMessage<CommitInfoPayload> = /*@__PURE__*/
  messageDesc(file_repos_tree_v1_commit_info, 0);

/**
 * @generated from message github.repos.tree.v1.CommitInfo
 */
export type CommitInfo = Message<"github.repos.tree.v1.CommitInfo"> & {
  /**
   * @generated from field: string oid = 1;
   */
  oid: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string date = 3;
   */
  date: string;

  /**
   * @generated from field: github.common.v1.SafeHtml short_message_html_link = 4;
   */
  shortMessageHtmlLink?: SafeHtml;
};

/**
 * Describes the message github.repos.tree.v1.CommitInfo.
 * Use `create(CommitInfoSchema)` to create a new message.
 */
export const CommitInfoSchema: GenMessage<CommitInfo> = /*@__PURE__*/
  messageDesc(file_repos_tree_v1_commit_info, 1);

import { registerSchemaHash } from "../../../../schema-hash-registry";
registerSchemaHash(CommitInfoPayloadSchema, "d6cf26b51adb")
registerSchemaHash(CommitInfoSchema, "9ef38a3a7222")
